import { Component, Input } from "@angular/core";
import { PrefixComponent } from "../../prefix.component";
import { MapOptions, MarkerData, TemplateMapComponent } from "../../templates/template-map/template-map.component";

@Component({
  selector: "app-prefix-gep",
  imports: [TemplateMapComponent],
  templateUrl: "./prefix-gep.component.html",
  styleUrl: "./prefix-gep.component.less",
})
export class PrefixGepComponent extends PrefixComponent<MarkerData[]> {
  @Input()
  public mode: TemplateMapComponent["mode"];
  public mapOptions: google.maps.MapOptions;
  public options: MapOptions;

  public constructor() {
    super();
    this.mapOptions = {};
    this.options = {};
    this.mode = "view";
  }
}
